export const TIME_VALUE_REGEX = /^\d{0,2}?:?\d{0,2}$/u;
